// Note: plain px numbers, not rem - `@media` queries resolve `rem`/`em` against the
// browser's default root font-size (usually 16px), not this app's `html { font-size: 62.5% }`
// override (1rem = 10px elsewhere), so a rem-based breakpoint here would silently mean
// something different than everywhere else in the codebase.
export const DefaultBreakpoints = {
  lg: 1200,
  md: 900,
  sm: 600,
  xl: 1536,
  xs: 0,
  xxl: 1920,
  xxxl: 2560,
}

export type Breakpoints = typeof DefaultBreakpoints
